import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'icon-sort',
  templateUrl: './icon-sort.component.html',
  styles: []
})
export class IconSortComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
